import moment from "moment";
import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { db } from "../components/Firebase";
import pic from "../assets/images/delete.png";
import create from "../assets/images/create.jpeg";

const Status = () => {
  const [input, setStatus] = useState("");
  //console.log(input);
  let location = useLocation();
  const navigate = useNavigate();
  //console.log(location);

  const [notification, setNotification] = useState([]);
  //console.log("object", notification);
  const onDelete = (index) => {
    //console.log(index, "index");
    const newNotification = [...notification];
    newNotification.splice(index, 1);
    setNotification(newNotification);
    db.collection("status")
      .doc("status")
      .set({ status: newNotification })
      .then(() => {
        alert("deleted");
      });
  };
  const onSubmit = () => {
    if(input)
    db.collection("status")
      .doc("status")
      .update({ status: [...notification, input] })
      .then(() => {
        setNotification([...notification, input]);
        setStatus("");
      });
  };
  useEffect(() => {
    db.collection("status")
      .get()
      .then((docs) => {
        let data = [];
        docs.forEach((i) => {
          data = i.data().status;
        });
        setNotification([...data]);
      });
  }, []);
  return (
    <div class="container-fluid">
  <div class="container">
    <div class="row">
      <div class="col-md-12" style={{ paddingBottom: "10px" }}>
        <h1 style={{ textAlign: "center" }}>Status</h1>
      </div>
      <div class="col-md-3" style={{ textAlign: "center", paddingBottom: "40px" }}>
        <div class="btn-group">
          <input placeholder="Add New" class="form-control" value={input} onChange={(e) => {setStatus(e.target.value);}} />
          <img src={create} onClick={onSubmit} style={{ display: "block", width: "40px" }} class="img-responsive"/>
        </div>
      </div>
      <div class="col-md-9"></div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
          {notification.map((i, index) => {
            return (
              <tr>
                <td>{i}</td>
                <td><img style={{ display: "block", width: "20px" }} onClick={() => { onDelete(index); }} src={pic} class="img-responsive" /></td>
              </tr>
              );
           })}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
  );
};

export default Status;
